import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("REPORTS");
const CRUD_ACTION_HANDLERS = getActionHandler("REPORTS");

export default function tamaracReports(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
